<div class="container-fluid">
  <div class="row">
    <div class="col">
      <a class="btn btn-round btn-brand-secondary" routerLink="/">
        <fa-icon [icon]="iconArrow" [fixedWidth]="true" ngClass="me-1"></fa-icon><b>Dashboard</b>
      </a>
    </div>
    <div class="col text-end">
      <a *ngIf="false" class="btn btn-round btn-light text-secondary" routerLink="/">
        <fa-icon [icon]="iconQuestion" [fixedWidth]="true" ngClass="me-1 text-secondary"></fa-icon>Help
      </a>
    </div>
  </div>
</div>
